<template>
  <a
    class="rich-card-button"
    v-if="uri"
    :target="urlHandling === 'new-tab' ? '_blank' : '_self'"
    rel="noopener noreferrer"
    :href="uri">
    <arrow-right class="rich-card-button-icon" :size="18" />
    <!-- <i class="material-icons rich-card-button-icon" aria-hidden="true">arrow_forward</i> -->
    <span class="rich-card-button-title">{{title || uri}}</span>
  </a>
  <button class="rich-card-button" :size="18" v-else @click="$emit('click')">
    <i class="material-icons rich-card-button-icon" aria-hidden="true">reply</i>
    <span class="rich-card-button-title">{{title}}</span>
  </button>
</template>

<style lang="sass" scoped>
@import '@/style/mixins'

.rich-card-button
  @include reset
  display: flex
  text-decoration: none
  color: var(--text-primary)
  border: var(--border)
  border-radius: 16px
  padding: 7px 8px
  cursor: pointer
  justify-content: space-between
  flex: 1

  &[href]
    color: var(--accent)
    align-items: center
    margin-top: 6px

  span.rich-card-button-icon
    display: flex

.rich-card-button-title
  flex: 1
  text-align: center
</style>

<script>
import ArrowRight from 'vue-material-design-icons/ArrowRight.vue'
export default {
  name: 'RichCardButton',
  emits: ['click'],
  components: {
    ArrowRight
  },
  props: {
    uri: {
      type: String,
      default: null
    },
    title: {
      type: String
    },
    urlHandling: {
      type: String,
      required: true
    }
  }
}
</script>
